numSize